import { useMount, useUnmount, useUpdateEffect } from 'ahooks';
import { useSocket, useSocketEvent } from 'socket.io-react-hook';

import { useGetAppSocket } from './useGetAppSocket';

export const useAppSocket = <D>(
  eventName: string,
  cb: (args: Omit<ReturnType<typeof useSocketEvent<D>>, 'socket' | 'sendMessage'>) => void,
  events?: {
      onConnect?: (eventSocket: ReturnType<typeof useSocket>['socket']) => void;
      onDisconnect?: (eventSocket: ReturnType<typeof useSocket>['socket']) => void;
      onError?: (eventSocket: ReturnType<typeof useSocket>['socket']) => void;
      onMount?: (eventSocket: ReturnType<typeof useSocket>['socket']) => void;
      onUnmount?: (eventSocket: ReturnType<typeof useSocket>['socket']) => void;
    }
): void => {
  const { onConnect, onDisconnect, onError, onMount, onUnmount } = events || {};

  const { socket, } = useGetAppSocket();

  const {
    error,
    lastMessage,
    status,
    socket: socketInstance,
  } = useSocketEvent<D>(socket, eventName);

  useUpdateEffect(() => {
    if (lastMessage && cb) {
      cb({ error, lastMessage, status });
    }
  }, [lastMessage, eventName]);

  useUpdateEffect(() => {
    if (status === 'connected') {
      onConnect?.(socketInstance);
    }
    if (status === 'disconnected') {
      onDisconnect?.(socketInstance);
    }
  }, [status, socketInstance]);

  useUpdateEffect(() => {
    if (error) {
      onError?.(socketInstance);
    }
  }, [error, socketInstance]);

  useMount(() => {
    onMount?.(socketInstance);
  });

  useUnmount(() => {
    onUnmount?.(socketInstance);
  });
};
